import { useEffect, useState } from "react";
import rune1 from "../assets/runes/rune1.png";
import rune2 from "../assets/runes/rune2.png";
import rune3 from "../assets/runes/rune3.png";
import rune4 from "../assets/runes/rune4.png";
import rune5 from "../assets/runes/rune5.png";
import rune6 from "../assets/runes/rune6.png";
import rune7 from "../assets/runes/rune7.png";
import rune8 from "../assets/runes/rune8.png";
import rune9 from "../assets/runes/rune9.png";
import rune10 from "../assets/runes/rune10.png";
import rune11 from "../assets/runes/rune11.png";
import rune12 from "../assets/runes/rune12.png";

export type ModalStates = "void" | "pass" | "lose" | "true";

const runes = [
  rune1,
  rune2,
  rune3,
  rune4,
  rune5,
  rune6,
  rune7,
  rune8,
  rune9,
  rune10,
  rune11,
  rune12
];

const altarsNumber = 4;
const secuenceLenght = 8;

const useRunicMemorise = () => {
  const [start, setStart] = useState(false);
  const [iluminate, setIluminate] = useState(false);

  const [currentIndexSelect, setCurrentIndexSelect] = useState(0);

  const [checkInputArray, setCheckInputArray] = useState<string[]>([]);
  const [runesArray, setRunesArray] = useState<string[]>([]);
  const [secuenceArray, setSecuenceArray] = useState<string[]>([]);

  const [simonState, setSimonState] = useState("simonHace");

  const [testingInput, setTestingInput] = useState<ModalStates>("void");

  function randomRunes() {
    const runesAux: string[] = [];
    while (runesAux.length < altarsNumber) {
      const randomGenerator = Math.floor(Math.random() * (11 - 0 + 1) - 0);
      if (!runesAux.find(rune => rune === runes[randomGenerator])) {
        runesAux.push(runes[randomGenerator]);
      }
    }
    setRunesArray(runesAux);
  }

  function secuence() {
    const secuenceAux: string[] = [];
    const runesArrayLenght = runesArray.length;
    for (let index = 0; index < secuenceLenght; index++) {
      const secuenceGenerator = Math.floor(Math.random() * runesArrayLenght);
      secuenceAux.push(runesArray[secuenceGenerator]);
    }
    setSecuenceArray(secuenceAux);
  }

  function reset() {
    setStart(false);
    setIluminate(false);
    setCurrentIndexSelect(0);
    setCheckInputArray([]);
    setRunesArray([]);
    setSecuenceArray([]);
    setSimonState("simonDice");
    setTestingInput("void");
  }

  useEffect(() => {
    if (start) {
      setIluminate(() => true);
      if (currentIndexSelect < secuenceArray.length) {
        setSimonState("simonDice");
        setTimeout(() => {
          setIluminate(() => !iluminate);
          setCurrentIndexSelect(prev => prev + 1);
        }, 2000);
      } else if (currentIndexSelect == secuenceArray.length) {
        setSimonState("simonHace");
      }
    }
  }, [start, currentIndexSelect]);

  useEffect(() => {
    randomRunes();
  }, [start]);

  useEffect(() => {
    if (runesArray) {
      secuence();
    }
  }, [runesArray]);

  useEffect(() => {
    if (start) {
      if (checkInputArray.length !== 0) {
        if (
          checkInputArray[checkInputArray.length - 1] ===
          secuenceArray[checkInputArray.length - 1]
        ) {
          setTestingInput("true");
        } else {
          setTestingInput("lose");
        }
        if (checkInputArray.length === secuenceLenght) {
          setTestingInput("pass");
        }
      }
    }
  }, [start, checkInputArray]);

  return {
    start,
    setStart,
    runesArray,
    secuenceArray,
    iluminate,
    setIluminate,
    currentIndexSelect,
    setCurrentIndexSelect,
    checkInputArray,
    setCheckInputArray,
    setRunesArray,
    setSecuenceArray,
    simonState,
    setSimonState,
    setTestingInput,
    testingInput,
    reset
  };
};
export default useRunicMemorise;
